<template>
  <div id="container">
    <div class="full_layout">
      <div class="shopping_cart" v-if="!nofind">
        <div class="shopping_box">
          <div class="shopping_checkbox_box">
            <el-checkbox class="shopping_checkbox_all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
            </el-checkbox>
            <div class="shopping_delete" :class="checkedCities.length>0?'on':''" v-if="checkedCities.length>0" @click="CartDelete()">{{$t('base.delete')}}
            </div>
            <div class="shopping_delete" v-else>{{$t('base.delete')}}</div>
          </div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <div class="shopping_box_list" v-for="(item,index) in list" :key="index">
              <el-checkbox class="" :label="item" :disabled='item.disabled'>
              </el-checkbox>
              <div class="shopping_list">
                <div class="like_box" :class="{'soldout':item.disabled}">
                  <el-image class="like_img" :src="item.Imgs[0]" fit="contain"></el-image>
                  <span class="iconsold" v-if="item.Status==0">{{$t('base.soldOut')}}</span>
                  <span class="iconsold ReleaseType" v-if="(item.IsWarm==1&&item.Status!=0)||item.Status==2">{{$t('base.comingSoon')}}</span>
                  <div>
                    <router-link class="line_txt2 cart_div" :to="{path:'/storedetails/'+item.CommodityId}">{{item.Title}}</router-link>
                    <span class="ConditionName">{{item.ConditionName}}</span>
                  </div>
                  <!-- {{item.ConditionName}} -->
                  <div class="text_blue delete" @click="delShop(item)">{{$t('base.delete')}}</div>
                </div>
                <div class="list_price">
                  <div class="SetCart">
                    <el-input-number v-model="item.Num" :disabled="item.disabled?item.disabled:item.loading" @change="SetCart(item,index)" :min="1" :max="item.LimitNum<=0?item.QuantitySold:item.LimitNum" label=""></el-input-number>
                    <div class="text-right">
                      <div>{{item.Currency}} {{isNewPrice(item)}}</div>
                     <!--  <div class="text_gray line-through text-right" v-if="item.UnderlinedPrice" >{{item.Currency}} {{isNewPrice(item,'delPrice')}}</div> -->
                    </div>
                  </div>
                  <!-- 优惠，无 -->
                  <!-- <div>
                    <div class="coupon_box">
                      <el-select class="coupon_cart" v-model="item.Coupon" :placeholder="TotalCount>0?'Select Coupons':'No Coupons'" @visible-change="SetCommodity(item,index)" @change="SetCoupon(item,index)">
                        <el-option :label="typeof(item.FreeMoney)=='number'?'- $'+item.FreeMoney:item.FreeMoney" :value="item.ID" v-for="(item,index) in Coupon" :key="index" :disabled="item.disabled">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="text_greed" v-if="item.FreeMoney!=0&&item.FreeMoney!=undefined">- $ {{item.FreeMoney}}</div>
                  </div> -->
                </div>
              </div>
            </div>
          </el-checkbox-group>
          <!-- <div class="isdisabled" v-if="notlist!=''">
            <div class="shopping_box_list " v-for="(item,index) in notlist" :key="index">
              <div class="shopping_list">
                <div class="like_box">
                  <span class="sold">{{$t('base.soldOut')}}</span>
                  <el-image class="like_img" :src="item.Imgs[0]" fit="contain"></el-image>
                  <p><span class="isP line_txt3">{{item.Title}}</span>
                    <span class="ConditionName">{{item.ConditionName}}</span>
                    <span class="text_red">{{$t('base.notAvailable')}}</span>
                  </p>
                  <div class="text_blue delete" @click="delShop(item)">{{$t('base.delete')}}</div>
                </div>
                <div class="list_price">
                  <div class="SetCart">
                    <el-input-number disabled v-model="item.Num" :min="1" :max="item.LimitNum<=0?item.QuantitySold:item.LimitNum" label=""></el-input-number>
                    <div>{{item.Currency}} {{item.NewPrice}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="Checkout">
          <div class="check_list">
            <span>{{checkedCities.length != 1?$t('base.items'):$t('base.item')}} ({{checkedCities.length}})</span>
            <span>{{areaSymbol}} {{formatAmount(itemTotal)}}</span>
          </div>
          <!-- <div class="check_list">
            <span>Shipping to 97253-1776</span>
            <span>$28,788.00</span>
          </div> -->
          <div class="check_list" v-if="CouponSubtotal>0">
            <span>{{$t('base.coupon')}}</span>
            <span class="text_greed">{{CouponSubtotal.toLocaleString()}}</span>
          </div>
          <div class="check_list check_list_all">
            <span>{{$t('base.subtotal')}}</span>
            <span>{{areaSymbol}} {{formatAmount(Subtotal)}}</span>
          </div>
          <el-button class="check_btn" type="primary" :disabled="checkedCities.length>0?false:true" @click="goto()">{{$t('base.goCheckout')}}
          </el-button>
        </div>
      </div>
      <n-o-t-n class="notfind" title="" text="No Data" v-if="nofind" />
      <!-- You May Also Like -->
      <like-swiper />
    </div>
  </div>
</template>
<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
import { countDown, getInfo, getTime, priceExchange,formatAmount, numAdd, numMulti, numSub, isNumber } from "@/api/public";
import LikeSwiper from "@/components/swiper/like";
import NOTN from "@/components/notnull.vue";
import qs from 'qs';
export default {
  inject: ['reload'],
  name: 'index',
  components: { LikeSwiper, NOTN },
  data() {
    return {
      areaSymbol: '',
      TotalCount: 0,
      userInfo: null,
      itemTotal: 0,
      Subtotal: 0,
      CouponSubtotal: 0,
      num: 1,
      value: '',
      list: '',
      oldList: null,
      Coupon: '',
      CouponCopy: [],
      notlist: '',
      checkAll: false,
      cities: [],
      checkedCities: [],
      nofind: false,
      isIndeterminate: false,
      UnusedCont: '',
    }
  },
  filters: {
    totalPrice(total, post) {
      return numAdd(isNumber(post), isNumber(total)).toLocaleString()
    }
  },
  mounted() {
    this.getMyCart()
  },
  created() {
    bus.$emit('headerTitle', this.$t('base.shoppingCart') + '( <span class="text_blue">0</span>&nbsp; ' + this.$t('base.items') + ')');
    this.userInfo = getInfo()
    //this.GetMyCoupon()
  },
  methods: {
    formatAmount(obj){
      return formatAmount(obj)
    },
    isNewPrice(obj,val) {
      if (obj.Status == 1) {
        if (obj.IsWarm == 1) {
          if(val){
            return formatAmount(obj.UnderlinedPrice)
          }else{
            if (obj.ShowPrice) {
              return formatAmount(obj.NewPrice)
            }
            return '???'
          }
        }
        return val?formatAmount(obj.UnderlinedPrice):formatAmount(obj.NewPrice)
      } else {
        if(val){
            return formatAmount(obj.UnderlinedPrice)
          }else{
        if (obj.ShowPrice) {
          return formatAmount(obj.NewPrice)
        }
        return '???'
        }

      }
    },
    // 获取购物车列表
    getMyCart() {
      let that = this;
      let data = { BuyerId: this.userInfo.MappingUserId, AreaCode: this.userInfo.MemberSource, PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetCartList, data).then(res => {
        if (res.Result != 0) {
          this.nofind = false
          let result = res.Data
          //console.log(result, 'res.Data[0]')
          if (res.Count > 0) {
            result.map(it => {
              it['loading'] = false
              it.disabled = false
              if (it.QuantitySold < 0) {
                it.disabled = true
              }
              // 预热
              if (it.IsWarm == 1) {
                it.disabled = true
              }
              // 商品状态
              if (it.Status !=1) {
                it.disabled = true
              }
            })
            that.list = result
            //that.notlist = no
            that.oldList = JSON.parse(JSON.stringify(result)) // 深拷贝一份作为参考数据
            that.cartNum = result.length
            that.$root.$emit('cardNum', that.cartNum)
            bus.$emit('headerTitle', this.$t('base.shoppingCart') + '( <span class="text_blue">' + that.cartNum + '&nbsp;</span> ' + (that.cartNum != 1 ? this.$t('base.items') : this.$t('base.item')) + ')');
          } else {
            this.nofind = true
          }
        } else {
          this.nofind = true
        }
      })
    },
    goto() {
      let commodityIds = [];
      let cuantitySold = [];
      let couponMemberID = [];
      let that = this;
      that.checkedCities.map(item => {
        item.Quantity = item.Num;
        commodityIds.push({ CommodityId: item.CommodityId, ConditionId: item.ConditionId });
        cuantitySold.push(item.Num);
        // couponMemberID.push(item.Coupon == undefined || item.Coupon == null || item.Coupon == 0 ? 0 : item.Coupon);
      })

      if (this.userInfo.Count > 0) {
        if (!this.userInfo.TelPhone) {
          this.isTelPhone()
        } else {
          let data = { total: that.Subtotal, subtotal: that.Subtotal, tax: '', commodityIds, cuantitySold, couponMemberID, Details: that.checkedCities }
          window.sessionStorage.setItem('check', JSON.stringify(data))
          this.$router.push({
            path: '/pay/storecheckout'
          })
        }
      } else {
        this.isAddCout()
      }


    },
    // 判断默认地址是否为空
    isAddCout() {
      if (!this.userInfo.TelPhone) {
        this.isTelPhone()
      } else {
        this.$confirm('You have not set your shipping address!', 'Something Important', {
          confirmButtonText: 'Go to Set',
          cancelButtonText: 'Cancel',
          lockScroll: false
        }).then(() => {
          let url = this.$router.resolve({ path: '/mycardhobby/setting' })
          window.open(url.href, '_blank');
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      }
    },
    // 判断用户是否存在手机号
    isTelPhone() {
      this.$confirm('Please set your Phone number!', 'Something Important', {
        confirmButtonText: 'Go to Set',
        cancelButtonText: 'Cancel',
        lockScroll: false
      }).then(() => {
        let url = this.$router.resolve({ path: '/mycardhobby/setting' })
        window.open(url.href, '_blank');
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
    // 全选
    handleCheckAllChange(val) {
      let that = this
      let data = [];
      if (val) {
        that.list.map(res => {
          if (!res.disabled) {
            data.push(res)
          }
        })
      }
      that.checkedCities = data;
      // if(data.length>0){
      //   data.map(res=>{
      //     res.CommodityList.map(item=>{
      //       that.checkedCities.push(item)
      //     })
      //   })
      // }

      this.isIndeterminate = false;
      this.SetTotal(this.checkedCities)
    },
    // 单选
    handleCheckedCitiesChange(value) {
      //console.log(value, 'value')
      let checkedCount = value.length;
      //bus.$emit('headerTitle','Shopping cart ( <span class="text_blue">'+checkedCount+'</span> Items)');
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
      //console.log(this.isIndeterminate,'isIndeterminate')
      this.SetTotal(value)
    },
    //根据选中商品更改总价
    SetTotal(obj) {
      let data = obj
      let totalArray = 0;
      //console.log(totalArray, 'totalArray')
      let CouponArray = 0;
      data.map(res => {
        totalArray = numAdd(isNumber(totalArray), numMulti(isNumber(res.NewPrice), isNumber(res.Num)))
        //CouponArray = numAdd(isNumber(CouponArray), isNumber(res.FreeMoney == undefined || res.FreeMoney == null ? 0 : res.FreeMoney))

      })
      this.itemTotal = totalArray
      this.Subtotal = numSub(totalArray, CouponArray) > 0 ? numSub(totalArray, CouponArray) : 0
      //this.CouponSubtotal = CouponArray == 0 ? CouponArray : '-$' + CouponArray
    },
    // 加入购物车用于更改当前商品数量
    SetCart(val, index) {
      let that = this;
      that.list[index].loading = true
      let data = {
        areaCode: val.AreaCode,
        buyerId: that.userInfo.MappingUserId,
        commodityId: val.CommodityId,
        conditionId: val.ConditionId,
        num: val.Num,
        coverOrAppend: 0
      }
      //console.log(data, val)
      that.$post(that.$interface.SetShopCart, data).then(res => {
        that.list[index].loading = false
        if (res.Result != 0) {
          if (that.checkedCities.length > 0) {
            that.checkedCities.map(r => {
              if (r.CommodityId == val.CommodityId) {
                r = val
                that.SetTotal(that.checkedCities)
              }
            })
          }
        } else {
          val.Num = that.oldList.CommodityList[index].Num
          val.maxNum = that.oldList.CommodityList[index].QuantitySold
          // val.Num = val.Num - 1
          // val.maxNum = val.Num
          this.$message({
            type: 'error',
            duration: 3000,
            // message: 'This item can be purchased up to ' + val.maxNum
            message: this.$t('alert.insufficientInventory')
          });
        }
        // that.list.CommodityList[i].loading = false
      })
    },
    // 删除购物车全部商品
    CartDelete() {
      //console.log(this.checkedCities)
      this.$confirm(this.$t('alert.allDeleteTip'), this.$t('title.clearAll'), {
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel'),
        lockScroll: false,
      }).then(() => {

        this.reDel(this.checkedCities)
        this.$message({
          type: 'success',
          message: this.$t('symbol.Delete')
        });
        this.reload()
      }).catch(() => {
        // this.$message({
        //   // type: 'info',
        //   // message: '已取消删除'
        // });
      });

    },
    // 删除单个商品
    delShop(obj) {
      let val = [obj]
      this.$confirm(this.$t('alert.itemDeleteTip'), this.$t('title.deleteItem'), {
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel'),
        lockScroll: false,
      }).then(() => {
        this.reDel(val)
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
    //删除购物车商品
    reDel(obj) {
      let that = this
      let ids = []
      obj.map(item => {
        ids.push(item.Id)
      })
      //console.log(obj, ids, 'ids')
      let data = { ids: ids }
      this.$post(this.$interface.RemoveShopCart, data).then(res => {
        if (res.result != 0) {
          this.reload()
          //this.getMyCart()
        }
      })
    },
    GetMyCoupon() {
      let that = this;
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, pageIndex: 1, pageSize: 99, type: 0 }
      this.$get(this.$interface.MyCoupon, data).then(res => {
        if (res.Result != 0) {
          // let unusedCoupon = res['data'].filter(obj => { if (obj.Status != 0) return obj });
          // this.Coupon = unusedCoupon;
          let name = this.$t('base.noCoupon')
          this.TotalCount = res.Count;
          if (res.Count > 0) {
            name = this.$t('base.DoNotUse')
            res.Data.sort((a, b) => {
              return b.FreeMoney - a.FreeMoney
            })
          }
          res.Data.map(r => {
            r.disabled = false
          })
          this.Coupon = res.Data
          this.Coupon.push({ "ID": 0, 'CouponID': 0, "Title": 'Not applicable', "FreeMoney": name, "IsAllUse": true, 'disabled': false })
        }
      })
    },
    SetCouponInfo(val, obj) {
      val.CouponID = obj.CouponID
      val.FreeMoney = obj.FreeMoney
      //console.log(1111, val, obj)
      return val
    },
    // 标灰
    SetGary() {
      let that = this;
      let array = [];
      that.Coupon.map((res, i) => {
        res.disabled = false
        that.CouponCopy.map(r => {
          if (res.ID == r.CouponId) {
            if (res.ID != 0) {
              res.disabled = true
              array.push(i)
            } else {
              res.disabled = false
            }
          }
        })
      })
      //console.log(array, 'a')
    },
    //设置优惠券
    SetCoupon(val, index) {
      let that = this
      // 判断是否是不需要优惠券
      if (val.Coupon != 0) {
        let isRepeat = 0;
        that.CouponCopy.map(res => {
          // that.Coupon.map((item,i)=> {
          //   if(res.CouponId==item.ID){
          //     if(item.ID!=0){item.disabled=true}
          //   }else{
          //     item.disabled=false
          //   }
          // })

          // if (res.IsAllUse == false) {
          //   res.disabled = true
          //   res.Commoditys.map(r => {
          //     console.log(r == val.CommodityId, 'r')
          //     if (r == val.CommodityId) {
          //       res.disabled = false;
          //     }
          //   })
          // }
          if (res.CouponId == val.Coupon) {
            isRepeat = 1
          }
        })
        let data = {}
        that.Coupon.map(r => {
          if (r.ID == val.Coupon) {
            if (r.ID != 0) { r.disabled = true }
            data = { "ID": r.ID, 'CouponID': r.CouponID, "Title": r.Title, "FreeMoney": r.FreeMoney }
          }
        })
        // 是否有重复优惠券  0：无，1：有

        //console.log(isRepeat, 'isRepeat')
        if (isRepeat == 0) {
          // console.log('that.CouponCopy[index].CouponId', that.CouponCopy[index])
          // console.log('val.Coupon', val)
          that.CouponCopy[index].CouponId = val.Coupon;
          val = this.SetCouponInfo(val, data)
          this.SetGary();
          this.checkedCities[index] = val
          this.SetTotal(this.checkedCities)
        } else {
          // 重复的优惠券，判断是否是不需要优惠券
          if (that.CouponCopy[index].CouponId != 0) {
            val.Coupon = that.CouponCopy[index].CouponId;
            val = this.SetCouponInfo(val, data)
          } else {
            val.Coupon = null
          }
          this.checkedCities[index] = val
          this.SetTotal(this.checkedCities)
          this.$message({
            type: 'error',
            message: this.$t('base.no')
          });

        }
      } else {
        that.CouponCopy[index].CouponId = val.Coupon
        val.CouponID = null
        val.FreeMoney = null
        this.SetGary();
        this.checkedCities[index] = val
        this.SetTotal(this.checkedCities)
      }
    },
    SetCommodity(val, index) {
      let that = this
      this.Coupon.map(res => {
        if (res.IsAllUse == false) {
          res.disabled = true
          if (res.Commoditys) {
            res.Commoditys.map(r => {
              // console.log(r == val.CommodityId, 'r')
              if (r == val.CommodityId) {
                res.disabled = false;
              }
            })
          }
        }
      })
    }

  }
}

</script>
<style scoped>
@import "../../../static/css/paycart.css";

.list_price {
  width: 440px;
}

.coupon_cart {
  width: 180px;
  line-height: 24px;
  position: relative;
  padding-left: 60px;
}

.coupon_cart:before {
  content: "Coupon:";
  position: absolute;
  width: 60px;
  left: 0;
  top: 0;
  z-index: 1;
}

.isdisabled .shopping_box_list {
  padding-left: 30px;
}

.isdisabled .shopping_box_list .isP {
  width: 270px;
  display: -webkit-box;
}

.cart_div {
  width: 270px;
  height: 40px;
}

/deep/ .SetCart .el-input-number {
  width: 152px;
}

/deep/ .SetCart .el-input-number .el-input__inner {
  height: 32px;
}

/deep/ .SetCart .el-input-number__decrease,
/deep/ .SetCart .el-input-number__increase {
  line-height: 30px;
}

/deep/ .el-input.is-active .el-input__inner,
/deep/ .el-input__inner:focus {
  border-color: #c0c4cc;
}

.sold {
  position: absolute;
  z-index: 2;
  width: 88px;
  bottom: 0;
  color: #fff;
  background-color: #a0a0a0;
  text-align: center;
  padding: 2px 0;
}

.ConditionName {
  border-radius: 2px;
  padding: 4px 12px;
  color: #a0a0a0;
  background: #f7f7f7;
}

.soldout {
  position: relative;
}

.soldout .iconsold {
  position: absolute;
  width: 88px;
  background-color: #a0a0a0;
  color: #fff;
  text-align: center;
  bottom: 0;
}

.soldout .ReleaseType {
  background-color: #5F6DAE;
}

</style>



// WEBPACK FOOTER //
// src/pages/pay/cart.vue